import React, { ReactElement, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS, FONT } from './tokens';

export interface SectionHeaderProps {
  eyebrow?: string;
  count?: number;
  title: string;

  action?: ReactNode;

  titleId?: string;

  titleSize?: number;
}

export const SectionHeader = ({
  eyebrow,
  count,
  title,
  action,
  titleId,
  titleSize = 22,
}: SectionHeaderProps): ReactElement => (
  <Box display="flex" flexDirection="column" gap="4px" width="100%">
    {eyebrow && (
      <Typography
        sx={{
          fontFamily: FONT,
          fontWeight: 500,
          fontSize: '11px',
          letterSpacing: '1.2px',
          textTransform: 'uppercase',
          color: COLORS.mutedAlt,
          lineHeight: 'normal',
        }}
      >
        {count !== undefined ? `${eyebrow} · ${count}` : eyebrow}
      </Typography>
    )}
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      sx={{ pb: '4px' }}
    >
      <Typography
        id={titleId}
        component="h2"
        sx={{
          fontFamily: FONT,
          fontWeight: 600,
          fontSize: `${titleSize}px`,
          color: COLORS.headingDark,
          lineHeight: 'normal',
          m: 0,
        }}
      >
        {title}
      </Typography>
      {action}
    </Box>
  </Box>
);
